'use client';

import { useState } from 'react';
import { Check, Share } from 'lucide-react';
import { copyToClipboard } from '@/utils/clipboard';
import { toAnchorId } from '@/utils/content/anchors';

type ChartHeaderProps = {
  title: string;
  description: string;
};

export default function ChartHeader({ title, description }: ChartHeaderProps) {
  const [copied, setCopied] = useState(false);

  // Generate anchor ID from title (same slug logic as the CMS section headers)
  const anchorId = toAnchorId(title);

  const handleShare = async () => {
    try {
      const url = `${window.location.origin}${window.location.pathname}#${anchorId}`;
      await copyToClipboard(url);
      setCopied(true);
      setTimeout(() => setCopied(false), 2000);
    } catch (err) {
      console.error('Failed to copy URL: ', err);
    }
  };

  return (
    <div className="mb-5 flex flex-col gap-4 sm:flex-row sm:items-start sm:justify-between">
      <div>
        <h3 id={anchorId} className="scroll-mt-24 text-2xl font-bold text-white">
          {title}
        </h3>
        <p className="mt-2 text-base text-zinc-400">{description}</p>
      </div>
      <button
        type="button"
        onClick={handleShare}
        className="flex h-[50px] w-32 shrink-0 items-center justify-center gap-2 self-end rounded-full border border-white px-4 text-base text-white sm:self-auto"
        title="Copy link to clipboard"
      >
        {copied ? (
          <>
            <Check size={20} color="#00FF00" />
            <span style={{ color: '#00FF00' }}>Copied</span>
          </>
        ) : (
          <>
            <Share size={20} />
            <span>Share</span>
          </>
        )}
      </button>
    </div>
  );
}
